import { useEffect, useState } from 'react';
import Input from '../../../../shared/components/Input/Input';
import Dialog from '../../../../shared/components/Dialog/Dialog';
import { AFFAIR_PROJECT_TYPES, affairToApiPayload, createEmptyAffairForm } from '../affairModel';
import { hasValidationErrors, validateAffair } from '../affairValidation';

const partnerName = (partner) => partner.socialReason || partner.social_reason || partner.name || `Partenaire ${partner.id}`;
const userName = (user) => user.name || [user.firstName || user.first_name, user.lastName || user.last_name].filter(Boolean).join(' ') || user.email || `Utilisateur ${user.id}`;

export default function AffairCreationDialog({ companyId = '', loading = false, onClose, onSubmit, open, partners = [], users = [] }) {
  const [form, setForm] = useState(() => createEmptyAffairForm({ companyId }));
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setForm(createEmptyAffairForm({ companyId }));
      setErrors({});
    }
  }, [companyId, open]);

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: undefined }));
  };

  const submit = () => {
    const validationErrors = validateAffair(form);
    setErrors(validationErrors);
    if (!hasValidationErrors(validationErrors)) onSubmit(affairToApiPayload(form));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onSubmit={submit}
      title="Créer une affaire"
      submitLabel="Créer l’affaire"
      loading={loading}
      size="large"
    >
      <div className="affair-creation-sections">
      <fieldset className="affair-creation-group"><legend>Dossier</legend><div className="affair-creation-grid">
        <div className={`custom-input custom-input--full ${errors.companyId ? 'custom-input--error' : ''}`}>
          <label className="custom-input__label" htmlFor="affair-company">Partenaire *</label>
          <select id="affair-company" className="custom-input__field" name="companyId" value={form.companyId} onChange={updateField}>
            <option value="">Sélectionner</option>
            {partners.map((partner) => <option key={partner.id} value={partner.id}>{partnerName(partner)}</option>)}
          </select>
          {errors.companyId && <span className="custom-input__help">{errors.companyId}</span>}
        </div>
        <Input fullWidth required label="Nom de l’affaire" name="name" value={form.name} onChange={updateField} error={errors.name} />
        <Input fullWidth multiline rows={3} label="Besoin / objet" name="description" value={form.description} onChange={updateField} />
      </div></fieldset>
      <fieldset className="affair-creation-group"><legend>Pilotage</legend><div className="affair-creation-grid">
        <div className="custom-input custom-input--full"><label className="custom-input__label" htmlFor="affair-commercial-manager">Responsable d'affaire</label><select id="affair-commercial-manager" className="custom-input__field" name="ownerUserId" value={form.ownerUserId} onChange={updateField}><option value="">Non attribué</option>{users.map((user) => <option key={user.id} value={user.id}>{userName(user)}</option>)}</select></div>
        <div className="custom-input custom-input--full"><label className="custom-input__label" htmlFor="affair-study-manager">Responsable d’études</label><select id="affair-study-manager" className="custom-input__field" name="technicalLeadUserId" value={form.technicalLeadUserId} onChange={updateField}><option value="">Non attribué</option>{users.map((user) => <option key={user.id} value={user.id}>{userName(user)}</option>)}</select></div>
        <Input fullWidth label="Échéance de réponse" type="datetime-local" name="responseDeadline" value={form.responseDeadline} onChange={updateField} error={errors.responseDeadline} />
      </div></fieldset>
      <fieldset className="affair-creation-group"><legend>Estimation</legend><div className="affair-creation-grid">
        <Input fullWidth label="Montant estimé" type="number" name="estimatedAmount" value={form.estimatedAmount} onChange={updateField} error={errors.estimatedAmount} inputProps={{ min: 0 }} />
        <div className={`custom-input custom-input--full ${errors.projectType ? 'custom-input--error' : ''}`}><label className="custom-input__label" htmlFor="affair-project-type">Type de projet</label><select id="affair-project-type" className="custom-input__field" name="projectType" value={form.projectType} onChange={updateField}><option value="">Non renseigné</option>{AFFAIR_PROJECT_TYPES.map((type) => <option key={type} value={type}>{type}</option>)}</select>{errors.projectType && <span className="custom-input__help">{errors.projectType}</span>}</div>
        <Input fullWidth label="Ville" name="city" value={form.city} onChange={updateField} />
      </div></fieldset></div>
    </Dialog>
  );
}
